require("./brokerCryptoTestDocumentation.scss");
// @vendors
import React, { useEffect } from "react";
import PropTypes from 'prop-types';
const { FormattedText, formatText } = require('core/i18n').i18n;

// @components
import { CryptoModalDocumentation } from "../brokerCryptoModalDocumentation/brokerCryptoModalDocumentation";
import { LoadingSection } from 'commonsComponents/loadingSection';

// @helpers
import { taggingEventHandled } from 'utilities/taggingEventHandled';

// @constants
import { PROC_BROKER_CONVENIENCE_CRYPTO_TEST } from 'utilities/tagging';

export default function BrokerCryptoTestDocumentation({
    isModalDocumentationOpen,
    closeModalDocumentation,
    getCryptoDocumentation,
    immBrokerConvenienceMiFIDTest,
    goToPurchaseFlow,
    goToSignDocumentation,
}) {
    const handleCloseDocumentation = () => {
        taggingEventHandled(PROC_BROKER_CONVENIENCE_CRYPTO_TEST, 'modalDocumentationClose');
        closeModalDocumentation();
    };

    if(immBrokerConvenienceMiFIDTest.getIn(["test", "cryptoDocumentation", "cryptoOperationProcessIdLoading"])) {
        return(
            <div className="test-documentation__container">
                <LoadingSection />
            </div>
        );
    }

    return (
        <div className="test-documentation__container">
            <h2 className="test-documentation__title">
                {formatText('brokerCryptoTest-documentationTitle')}
            </h2>
            <div className="test-documentation__description-container">
                <FormattedText value="brokerCryptoTest-documentationContent" />
            </div>
            <CryptoModalDocumentation
                isOpen={isModalDocumentationOpen}
                onClose={() => handleCloseDocumentation()}
                immBrokerConvenienceMiFIDTest={immBrokerConvenienceMiFIDTest}
                goToPurchaseFlow={goToSignDocumentation}
                getCryptoDocumentation={getCryptoDocumentation}
            />
        </div>
    );
}

BrokerCryptoTestDocumentation.propTypes = {
    isModalDocumentationOpen: PropTypes.bool.isRequired,
    closeModalDocumentation: PropTypes.func.isRequired,
    getCryptoDocumentation: PropTypes.func.isRequired,
    goToSignDocumentation: PropTypes.func.isRequired,
    goToPurchaseFlow: PropTypes.func.isRequired,
    immBrokerConvenienceMiFIDTest: PropTypes.object.isRequired,
};
